const API_BASE_URL = process.env.REACT_APP_API_ADDRESS;
const A = `${API_BASE_URL}/anonymization/pii`;

const authHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${localStorage.getItem("access_token")}`,
});

export const getUsageStats = async () => {
  const res = await fetch(`${A}/usage-stats/`, { headers: authHeaders() });
  if (!res.ok) throw new Error(`Nepodarilo sa načítať štatistiky (stav ${res.status}).`);
  return res.json();
};

export const getLicensePlans = async () => {
  const res = await fetch(`${A}/license-plans/`, { headers: authHeaders() });
  if (!res.ok) throw new Error(`Nepodarilo sa načítať cenník (stav ${res.status}).`);
  return res.json();
};

// Vytvorí žiadosť o zmenu programu (bežný user -> pending; superuser -> hneď schválené)
export const changeLicense = async (program, extra = {}) => {
  const res = await fetch(`${A}/license/change/`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({ program, ...extra }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.detail || `Žiadosť zlyhala (stav ${res.status}).`);
  return { ...data, _status: res.status };
};

export const getLicenseChanges = async (status = null) => {
  const url = status ? `${A}/license-changes/?status=${encodeURIComponent(status)}` : `${A}/license-changes/`;
  const res = await fetch(url, { headers: authHeaders() });
  if (!res.ok) throw new Error(`Nepodarilo sa načítať zmeny licencie (stav ${res.status}).`);
  return res.json();
};

export const approveLicenseChange = async (id) => {
  const res = await fetch(`${A}/license-changes/${id}/approve/`, { method: "POST", headers: authHeaders() });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.detail || `Schválenie zlyhalo (stav ${res.status}).`);
  return data;
};

export const rejectLicenseChange = async (id, note = "") => {
  const res = await fetch(`${A}/license-changes/${id}/reject/`, {
    method: "POST", headers: authHeaders(), body: JSON.stringify({ note }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.detail || `Zamietnutie zlyhalo (stav ${res.status}).`);
  return data;
};

export const downloadAddendum = async (id, filename = "dodatok.pdf") => {
  const res = await fetch(`${A}/license-changes/${id}/addendum/`, { headers: { Authorization: `Bearer ${localStorage.getItem("access_token")}` } });
  if (!res.ok) throw new Error(`Stiahnutie dodatku zlyhalo (stav ${res.status}).`);
  const blob = await res.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = filename;
  document.body.appendChild(a); a.click(); a.remove();
  window.URL.revokeObjectURL(url);
};
